var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full"},[_c('LaunchedApp'),_c('Launchers'),(_vm.shouldShowScreenSaver)?_c('ScreenSaver',{on:{"change":function($event){return _vm.setActive()}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }